export default __webpack_public_path__ + "static/media/hht2_ep10_speaking_02.8fb2fde5.png";